import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import { Box, Heading, Text, Button, Icon } from "../elements";

export class AskConfirm extends Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      show: false,
      // id: 0,
      // name: "",
      success: false,
      item: {},
      remark: "",
      show_remark: false,
    };
  }

  componentDidMount() {
    if (this.props.show) {
      this.props.show(this.show_modal);
    }
  }

  show_modal = (item, success, name, post) => {
    if (post) {
      this.setState({
        show: true,
        success,
        item,
        remark: "",
        show_remark: post.show_remark ? true : false,
      });
    } else {
      this.setState({
        show: true,
        success,
        item,
        remark: "",
        show_remark: false,
      });
    }
  };

  onYesPress = () => {
    this.props.onSubmit(this.state.item, { remark: this.state.remark });
    this.setState({ show: false });
  };

  render() {
    return (
      <>
        <Modal show={this.state.show} onHide={() => this.setState({ show: false })}>
          <Box className="mc-alert-modal">
            <Icon type="new_releases" />
            <Heading as="h3">are your sure!</Heading>
            <Text as="p">Want to delete {this.props.name ? `this ${this.props.name}` : "this"}?</Text>
            <Modal.Footer>
              <Button type="button" className="btn btn-secondary" onClick={() => this.setState({ show: false })}>
                nop, close
              </Button>
              <Button type="button" className="btn btn-danger" onClick={this.onYesPress}>
                yes, delete
              </Button>
            </Modal.Footer>
          </Box>
        </Modal>
      </>
    );
  }
}
